import { render, staticRenderFns } from "./SkeletonAdministratorDetailComponent.vue?vue&type=template&id=1cdafa98&scoped=true&"
import script from "./SkeletonAdministratorDetailComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonAdministratorDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonAdministratorDetailComponent.vue?vue&type=style&index=0&id=1cdafa98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdafa98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VDataTable,VDivider,VIcon,VRow,VSkeletonLoader,VSpacer,VSwitch})
